import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { MemberType } from '../../../../api/ceremony';
import { didPayForOrdination } from '../../../../helpers/checklistHelpers/ordainedHelper';
import { getCookie, setCookie } from '../../../../helpers/helper';
import useOrdained from '../../../../hooks/useOrdained';
import useOrders from '../../../../hooks/useOrders';
import { useChecklist } from '../../../../provider/checklistProvider';
import { useDashboard } from '../../../../provider/dashboardProvider';
import Button from '../../Button/Button';
import CampaignItem from '../../CampaignItem/CampaignItem';
import { Modal } from '../../Modal/Modal';
import { Typography } from '../../Typography/Typography';




const OfficiantAIOPopup = () => {
    const { currentUser, ceremony } = useDashboard();
    const { ordainedOrders, fetchOrders, ordersFetched } = useOrders();

    const { ordained, ordainedFetched, fetchOrdained } = useOrdained();
    const navigate = useNavigate();
    const url = useLocation();

    const [isOpen, setIsOpen] = useState(false);

    const officiantAioPopupCookie = getCookie('officiant-aio-popup-cooldown');

    useEffect(() => {

        if (!ordainedFetched) {
            void fetchOrdained();
            return;
        }

        if (!ordersFetched) {
            void fetchOrders();
            return;
        }

        const urlIsChecklist = url.pathname.includes('/checklist');
        const isOneHourPassed = officiantAioPopupCookie
            ? new Date(officiantAioPopupCookie).getTime() + 1000 * 60 * 60 < Date.now()
            : true;

        const paidForOrdination = didPayForOrdination(ordainedOrders);
        
        if (
            urlIsChecklist &&
            !paidForOrdination &&
            currentUser?.member_type === MemberType.officiant &&
            isOneHourPassed && 
            ordained
        ) {
            setIsOpen(true);
            setCookie('officiant-aio-popup-cooldown', new Date().toISOString(), 1);
        }

    }, [
        ordainedOrders,
        ordained,
        currentUser,
        url,
        ordainedFetched,
        ordersFetched
    ]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            fullWidth={false}
            fillScreen={false}
            maxWidth='lg'
        >
            <div className='self-center max-w-md flex flex-col justify-center text-center'>
                <Typography type='display-100' className='mb-4'>
                    Prepared to officiate?
                </Typography>
                <CampaignItem
                    hideIfPaid={false}
                    regularComponent={
                        <Typography type='body-400' className='mb-8'>
                            <>Gain access to all the tools you need to run a successful ceremony and print all your official credentials as well as helpful guides and more with an extra 10% off if you purchase now with code <u>GETSTARTED10</u></>
                        </Typography>
                    }
                    renderCampaignComponent={(discountPercentage, couponCode) => (
                        <Typography type='body-400' className='mb-8'>
                            <> {`Gain access to all the tools you need to run a successful ceremony and print all your official credentials as well as helpful guides and more with an extra ${discountPercentage}% off if you purchase right now with code `}
                                <u>{couponCode}</u>.</>
                        </Typography>
                    )}
                />
                <div className='flex flex-col-reverse md:flex-row justify-between'>
                    <Button
                        className='mt-2 md:mt-0 md:mr-2 md:w-auto w-full'
                        onClick={() => setIsOpen(false)}
                        variant='text'
                    >
                        Keep Exploring
                    </Button>
                    <Button
                        className='md:w-auto w-full'
                        onClick={() => {
                            setIsOpen(false)
                            navigate(`/ceremony/${ceremony?.id || ''}/ordained`)
                        }}
                    >
                        Get Started
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default OfficiantAIOPopup;
